import { money } from "@/lib/format";

/** A whole table or matrix is summarised rather than listed figure by figure. */
const isBulk = (change) => change.type === "table" || change.type === "matrix";

/** One figure, as it shipped and as it stands now. */
const Movement = ({ change }) => {
  if (isBulk(change)) {
    return (
      <span className="font-amount text-xs font-semibold text-[color:var(--tt-warn-text)]">
        edited
      </span>
    );
  }
  const show = (value) => (change.type === "percent" ? `${value}%` : money(value));
  return (
    <span className="font-amount text-xs font-semibold">
      <span className="text-muted-foreground line-through">{show(change.default)}</span>
      {" → "}
      <span className="text-primary">{show(change.current)}</span>
    </span>
  );
};

/** Everything that no longer matches the figures the calculator shipped with. */
export const ChangesFromDefault = ({ changes }) => (
  <div data-testid="rate-card-changes" className="mt-6 rounded-xl border border-border p-4">
    <h4 className="tt-eyebrow">Changed from the shipped defaults</h4>
    <ul className="mt-3 space-y-2">
      {changes.map((change) => (
        <li
          key={`${change.service}-${change.path}`}
          className="flex flex-wrap items-baseline justify-between gap-2 border-b border-border pb-2 text-[13px] last:border-0 last:pb-0"
        >
          <span className="text-muted-foreground">
            <span className="font-semibold text-foreground">{change.service_label}</span>
            {" · "}
            {change.label}
          </span>
          <Movement change={change} />
        </li>
      ))}
    </ul>
  </div>
);
